import { inject, ProviderToken } from '@angular/core';
import { IrisStorage } from './storage';
import { IrisStorageKeyContainer } from './storage-key';

export type IrisValueStorageFactory<T> = () => IrisValueStorage<T>;

export function valueStorageFactory<T = unknown>(
  storageToken: ProviderToken<IrisStorage>,
  keyContainerToken: ProviderToken<IrisStorageKeyContainer>,
): IrisValueStorageFactory<T> {
  return () => new IrisValueStorage<T>(inject(storageToken), inject(keyContainerToken));
}

export class IrisValueStorage<T> {
  constructor(
    private readonly storage: IrisStorage,
    private readonly keyContainer: IrisStorageKeyContainer,
  ) {
  }

  get(): T {
    const key = this.keyContainer.key;
    return key == null ? undefined : this.storage.getItem(key);
  }

  set(value: T): void {
    const key = this.keyContainer.key;

    if (key == null) {
      return;
    }

    this.storage.setItem(key, value);
  }

  remove(): void {
    const key = this.keyContainer.key;

    if (key == null) {
      return;
    }

    this.storage.removeItem(key);
  }
}
